import React, { useMemo, useCallback } from "react";
import { CheckSquare, XSquare, TriangleAlert, Ban } from "lucide-react";
import PropTypes from "prop-types";
import "./ApprovalActions.css";

const ApprovalActions = ({ voucher }) => {
  const isNonRefundable = useMemo(() => {
    return (
      voucher?.isRefundable === false || voucher?.isRequested === true
      // voucher?.isAppointmentGenerated === true
    );
  }, [
    voucher?.isRefundable,
    voucher?.isRequested,
    // voucher?.isAppointmentGenerated,
  ]);

  const getStatusConfig = useCallback(() => {
    if (isNonRefundable) {
      return {
        icon: <Ban className="status-icon non-refundable" />,
        color: "non-refundable",
        title: "Cannot Be Refunded",
      };
    }

    switch (voucher?.approvalStatus) {
      case "approved":
        return {
          icon: <CheckSquare className="status-icon approved" />,
          color: "approved",
          title: "Approved",
        };
      case "rejected":
        return {
          icon: <XSquare className="status-icon rejected" />,
          color: "rejected",
          title: "Rejected",
        };
      default:
        return {
          icon: <TriangleAlert className="status-icon pending" />,
          color: "pending",
          title: "Pending Approval",
        };
    }
  }, [isNonRefundable, voucher?.approvalStatus]);

  const getSubtitleText = useCallback(() => {
    if (voucher?.isRefundable === false || voucher?.isRequested === true) {
      return "This voucher is not eligible for refund due to request refund";
    }
    // if (voucher?.isAppointmentGenerated === true) {
    //   return "Appointments exist";
    // }
    return "This refund requires Head Office approval before processing";
  }, [
    voucher?.isRefundable,
    voucher?.isRequested,
    // voucher?.isAppointmentGenerated,
  ]);

  const statusConfig = getStatusConfig();
  const subtitleText = getSubtitleText();

  return (
    <div
      className={`approval-section ${isNonRefundable ? "non-refundable" : ""}`}
    >
      <div className="approval-header">
        <div className="approval-status">
          {statusConfig.icon}
          <div className="status-info">
            <h3 className={`status-title ${statusConfig.color}`}>
              {statusConfig.title}
            </h3>
            <p className={`status-subtitle ${isNonRefundable ? "danger" : ""}`}>
              {subtitleText}
            </p>
            {voucher?.isRequested === true &&
              voucher?.previousRequestStatus === "Declined" && (
                <span className="previous-request-notice">
                  ( Previous request was declined )
                </span>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

ApprovalActions.propTypes = {
  voucher: PropTypes.shape({
    isRefundable: PropTypes.bool,
    isRequested: PropTypes.bool,
    isAppointmentGenerated: PropTypes.bool,
    approvalStatus: PropTypes.oneOf(["Finished", "Declined", "Pending"]),
    previousRequestStatus: PropTypes.string,
  }),
};

ApprovalActions.defaultProps = {
  voucher: {},
};

export default ApprovalActions;
